import * as React from "react";
import classnames from "classnames";
import AppointmentTypeButtonContainer from "../../../../../../AppointmentTypeButton/v3/components/AppointmentTypeButton/AppointmentTypeButtonContainer.js";
const SingleAppointmentTypeList = ({
  className,
  appointmentTypes,
  appointmentTypeIcons,
  appointmentTypeToolTips,
  appointmentGlobalLabels,
  onClick,
  onClickToolTip,
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement("ul", { ...rest, className: classnames("appointment-type-list", className) }, appointmentTypes.map((appointmentType) => /* @__PURE__ */ React.createElement("li", { className: "appointment-type-list__item", key: appointmentType.id }, appointmentType.isVisibleToCustomers && /* @__PURE__ */ React.createElement(
    AppointmentTypeButtonContainer,
    {
      icon: appointmentTypeIcons[appointmentType.id],
      appointmentType,
      toolTip: appointmentTypeToolTips[appointmentType.id],
      onClick,
      onClickToolTip,
      "data-t": appointmentGlobalLabels[appointmentType.id] || appointmentType.id
    }
  ))));
};
export {
  SingleAppointmentTypeList as default
};
//# sourceMappingURL=SingleAppointmentTypeList.js.map
